import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const GetOrganizationQueryKey = 'GET_ORGANIZATION';

export const useGetOrganizationQuery = () => {
  const { getCurrentOrganization } = useServicesContext();

  return useQuery({
    queryKey: [GetOrganizationQueryKey],
    queryFn: () => getCurrentOrganization(),
  });
};
